/**
 * utils
 */

const base = {
  /**
   * 银行列表
   */
  bank: [
    { key: '1', name: '先行工商银行' },
    { key: '2', name: '先行杭州银行' },
    { key: '3', name: '先行建设银行' },
    { key: '4', name: '杭州联合银行' },
    { key: '5', name: '点实浦发银行' },
    { key: '6', name: '商美工商银行' },
    { key: '7', name: '朋广招商银行' },
    { key: '8', name: '企点工商银行' },
    { key: '9', name: '农业银行' },
    { key: '10', name: '工商银行' },
    { key: '11', name: '建设银行' },
    { key: '12', name: '帮腾招商银行' },
    { key: '13', name: '招商银行' },
    { key: '14', name: '先行支付宝' },
    { key: '15', name: '点实支付宝' },
    { key: '16', name: '朋广支付宝' },
    { key: '17', name: '帮腾支付宝' },
  ],

  /**
   * 申请类别
   */
  submitType: [
    { key: '1', name: '提前开票' },
    { key: '2', name: '到账开票' },
  ],

  /**
   * 收款方式
   */
  collectWay: [
    { key: '1', name: '汇款' },
    { key: '2', name: '现金' },
  ],

  bookType: [
    { key: '1', name: '支付宝' },
    { key: '2', name: '农业银行' },
    { key: '3', name: '工商银行(趣得)' },
    { key: '4', name: '建设银行' },
    { key: '5', name: '易宝' },
    { key: '6', name: '招商银行' },
    { key: '7', name: '杭州银行' },
    { key: '8', name: '邮政银行' },
    { key: '9', name: '工商银行(新华)' },
    { key: '10', name: '微信' },
    { key: '11', name: '连连支付/通联/贝宝' },
    { key: '12', name: '联合银行' },
    { key: '13', name: '旧版支付宝' },
    { key: '14', name: '泰隆银行' },
    { key: '15', name: '工商银行2(趣得)' },
    { key: '16', name: '建设银行2' },
  ],

  /**
   * 客户文件
   */
  attachmentType: [
    { key: '1', name: '法人身份证' },
    { key: '2', name: '消防安全责任书' },
    { key: '3', name: '营业执照' },
    { key: '4', name: '资产负债表（实缴注册资本低于300万元凭证）' },
    { key: '5', name: '特殊费用申请审批表' },
    { key: '6', name: '工位分布图' },
    { key: '7', name: '企业租赁合同' },
    { key: '8', name: '房产证' },
    { key: '9', name: '工位注册委托书' },
    { key: '10', name: '基础孵化服务协议' },
    { key: '11', name: '无偿使用证明' },
    { key: '12', name: '平面图' },
    { key: '16', name: '三方租赁合同' },
    { key: '17', name: '营业执照（物业主体供地址注册使用）' },
    { key: '18', name: '房租协议、合同' },
    { key: '19', name: '补充说明、申请报告' },
    { key: '20', name: '解除协议合同' },
    { key: '-1', name: '错误文件' },
  ],

  /** 投资回报类型 */
  investmentType: {
    investmentInit: '投资款',
    current: '现金余额',
    inOrOut: '往来款',
    depositInOrOut: '保证金',
    longInvestment: '长期股权投资',
    equityTransfer: '股权转让支出',
    financial: '理财款',
    fixed: '固定资产',
    decoration: '装修',
    sum: '总计',
  },

  model: [
    { key: '1', name: '入驻费米孵化器' },
    { key: '2', name: '入驻极讯孵化器' },
    { key: '3', name: '入驻创盒孵化器' },
    { key: '4', name: '入驻麦鲜孵化器' },
    { key: '5', name: '入驻远方极客孵化器' },
    { key: '6', name: '参加科创王牌活动' },
    { key: '7', name: '参加寻找掌门人活动' },
    { key: '8', name: '技术孵化' },
    { key: '9', name: '财务代理' },
    { key: '10', name: '知识产权' },
    { key: '12', name: '入驻一源极客孵化器' },
    { key: '13', name: '入驻点雇极客孵化器' },
    { key: '14', name: '入驻致客孵化器' },
    { key: '15', name: '入驻嵊州科创孵化器' },
    { key: '17', name: '入驻永客孵化器' },
  ],
};

export default base;



// WEBPACK FOOTER //
// ./src/util/base.js